import React, { useState, useEffect } from 'react';

import BackgroundSuperbet from '../../assets/superbet/fundo.png';
import BackgroundApostaGanha from '../../assets/apostaganha/fundo.png';
import BackgroundApostaGanhaMobile from '../../assets/apostaganha/mobile.png';
import BackgroundXpbet from "../../assets/xpbet/fundo.png";
import BackgroundXpbetMobile from "../../assets/xpbet/mobile.png";
import BackgroundFamilia from "../../assets/familiadepremios/fundo.png";
import BackgroundFamiliaMobile from "../../assets/familiadepremios/mobile.png";
import BackgroundBlueMobile from "../../assets/bluue/bluuembl.png";
import BackgroundBluePC from "../../assets/bluue/bluuepc.png";
import BackgroundRelaxeiPC from "../../assets/relaxei/relaxeipc.png"
import BackgroundRelaxeiMobile from "../../assets/relaxei/relaxeimbl.png"
import BackgroundGPlayPc from "../../assets/googleplay/gplaypc.png"
import BackgroundGPlayMbl from "../../assets/googleplay/gplaymbl.png" 

import styles from './styles';
import axios from 'axios';

const encode = encodeURIComponent;

const PLATFORMS = {
  superbet: {
    backgroundImage: { desktop: BackgroundSuperbet, mobile: BackgroundSuperbet },
    progressBarStyle: styles.progressBar,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://wlsuperbet.adsrv.eacdn.com/C.ashx?btag=a_9061b_434c_&affid=678&siteid=9061&adid=434&c=${source}`,
  },
  superturbo: {
    backgroundImage: { desktop: BackgroundSuperbet, mobile: BackgroundSuperbet },
    progressBarStyle: styles.progressBar,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://wlsuperbet.adsrv.eacdn.com/C.ashx?btag=a_9226b_431c_&affid=678&siteid=9226&adid=431&c=${source}`,
  },
  // BTAG DA 3G
  super: {
    backgroundImage: { desktop: BackgroundSuperbet, mobile: BackgroundSuperbet },
    progressBarStyle: styles.progressBar,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://wlsuperbet.adsrv.eacdn.com/C.ashx?btag=a_10607b_431c_&affid=572&siteid=10607&adid=431&c=${source}`,
  },

  // NOVO: aceita /bilhete/:idBilhete/:influencer
  // Mantém fallback para /bilhete/:influencer usando um ID padrão.
  bilhete: {
    backgroundImage: { desktop: BackgroundSuperbet, mobile: BackgroundSuperbet },
    progressBarStyle: styles.progressBar,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source, id }) => {
      if (!id) {
        return ''; // trate como inválido ou coloque seu ID padrão aqui se quiser
      }
  
      // mantém o ID original (com "-") para abrir a página
      const ascl = encodeURIComponent(`https://superbet.bet.br/bilhete-compartilhado/${id}`);
  
      // versão SEM hífen para os parâmetros da URL (tracking)
      const idNoDash = id.replace(/-/g, '');
  
      // opcional: centraliza a string comum nos parâmetros
      const tag = `${source}bilhete${idNoDash}`;
  
      return `https://wlsuperbet.adsrv.eacdn.com/C.ashx?btag=a_10607b_431c_&affid=572&siteid=10607&adid=431&c=${tag}&asclurl=${ascl}`;
    },
  },  
  
  apostaganha: {
    backgroundImage: { desktop: BackgroundApostaGanha, mobile: BackgroundApostaGanhaMobile },
    progressBarStyle: styles.progressBarApostaGanha,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://go.apostaganha.bet/visit/?bta=74214&brand=apostaganha&utm_campaign=${source}`,
  },
  xpbet: {
    backgroundImage: { desktop: BackgroundXpbet, mobile: BackgroundXpbetMobile },
    progressBarStyle: styles.progressBarApostaGanha,
    progressTextStyle: styles.loadingMessageWhite,
    redirectUrl: ({ source }) =>
      `https://xp.bet.br/adv/?btag=2296082_l351623_nId4353&utm_campaign=${source}&uniqueid=1`,
  },
  familiadepremios: {
    backgroundImage: { desktop: BackgroundFamilia, mobile: BackgroundFamiliaMobile },
    progressBarStyle: styles.progressBarFamilia,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://checkout.familiadepremios.com.br/?pdv_code=g5803e&utm_source=${source}`,
  },
  bluue: {
    backgroundImage: { desktop: BackgroundBluePC, mobile: BackgroundBlueMobile },
    progressBarStyle: styles.progressBarBluue,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://inlead.digital/bluue-consulta/?utm_source=${source}&b4f=EkjJTrF96o`,
  },
  relaxei: {
    backgroundImage: { desktop: BackgroundRelaxeiPC, mobile: BackgroundRelaxeiMobile },
    progressBarStyle: styles.progressBarBluue,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://relaxei.com/relaxei?utm_source=${source}&utm_medium=${source}_relaxei&utm_campaign=tiktok`,
  },
  googleplay: {
    backgroundImage: { desktop: BackgroundGPlayPc, mobile: BackgroundGPlayMbl },
    progressBarStyle: styles.progressBarBluue,
    progressTextStyle: styles.loadingMessage,
    redirectUrl: ({ source }) =>
      `https://play.google.com/store/apps/details?id=com.felipefreire7.virawapp&pcampaignid=web_share`,
  },
};

const Home = () => {
  const [progress, setProgress] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [backgroundImage, setBackgroundImage] = useState('');
  const [progressBarStyle, setProgressBarStyle] = useState({});
  const [progressTextStyle, setProgressTextStyle] = useState({});

  function generate() {
    return 'event_' + Date.now();
  }

  useEffect(() => {
    const getPathSegments = () => {
      const path = window.location.pathname;
      const segments = path.split('/').filter(Boolean);
      return segments;
    };

    const sanitizeSource = (s) => (s || '').replace(/[_\.]/g, '');
    const sanitizeId = (s) => (s || '').replace(/[^A-Za-z0-9\-]/g, ''); // permite letras, números e hífen

    const segments = getPathSegments();

    if (segments.length < 2) {
      setLoadingMessage('❌ URL inválido!');
      return;
    }

    const [platform, seg2, seg3] = segments;
    const platformConfig = PLATFORMS[platform];

    if (!platformConfig) {
      setLoadingMessage('❌ Plataforma desconhecida!');
      return;
    }

    // Layout
    const isMobile = window.innerWidth <= 768;
    setBackgroundImage(isMobile ? platformConfig.backgroundImage.mobile : platformConfig.backgroundImage.desktop);
    setProgressBarStyle(platformConfig.progressBarStyle);
    setProgressTextStyle(platformConfig.progressTextStyle);

    // Roteamento:
    // - Padrão (todas plataformas): /:platform/:source  => source = seg2
    // - Bilhete novo: /bilhete/:idBilhete/:influencer => id = seg2, source = seg3
    let source, id;

    if (platform === 'bilhete' && segments.length >= 3) {
      id = sanitizeId(seg2);
      source = sanitizeSource(seg3);
    } else {
      source = sanitizeSource(seg2);
      // id opcional em bilhete quando for legado (/bilhete/:source)
      if (platform === 'bilhete') {
        id = ''; // será tratado como defaultId na redirectUrl
      }
    }

    const redirectUrl = platformConfig.redirectUrl({ source, id });

    const referrer = document.referrer || '';
    const isFromInstagram = referrer.includes('instagram.com');

    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(interval);
          setLoadingMessage('✅ Concluído!');

          if (isFromInstagram) {
            axios.post("http://46.202.151.136/vps-virawapp/api/event-redirect.php", {
              username: source,
              instagram: true,
            });
          }

          if (typeof window.fbq === 'function') {
            const eventId = generate();
            window.fbq('track', platform, { eventID: eventId });
          }

          setTimeout(() => {
            window.location.replace(redirectUrl);
          }, 100);

          return 100;
        }
        const diff = 100 / 40;
        const newProgress = Math.min(oldProgress + diff, 100);
        updateLoadingMessage(newProgress);
        return newProgress;
      });
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const updateLoadingMessage = (progress) => {
    if (progress < 40.33) {
      setLoadingMessage('⏳ Carregando página...');
    } else if (progress < 72.66) {
      setLoadingMessage('🔓 Conexão segura...');
    } else if (progress < 85) {
      setLoadingMessage('✅ Concluído!');
    }
  };

  return (
    <div
      style={{
        ...styles.backgroundContainer,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div style={styles.progressContainer}>
        <div className="loading-message" style={{ ...styles.loadingMessage, ...progressTextStyle }}>
          {loadingMessage}
        </div>
        <div style={styles.progressBarContainer}>
          <div style={{ ...progressBarStyle, width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
};

export default Home;
